import React from "react";

const CTASection = () => {
    return (
        <section
            id="cta"
            className="bg-teal-500 text-white py-16 px-6 md:px-12 lg:px-20 text-center"
        >
            <div className="max-w-7xl mx-auto">
                {/* CTA Title */}
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                    Ready to take your project to the next level?
                </h2>
                {/* CTA Message */}
                <p className="text-lg mb-8">
                    Let’s work together to create something amazing. Whether it’s building a stunning website, designing a user-friendly interface, or developing custom features, I’m here to help!
                </p>
                {/* CTA Button */}
                <a
                    href="#contact"
                    className="inline-block bg-teal-700 hover:bg-teal-600 text-xl font-semibold py-3 px-8 rounded-lg shadow-lg transform hover:scale-105 transition duration-300"
                >
                    Let’s Connect
                </a>
            </div>
        </section>
    );
};

export default CTASection;
